document.addEventListener('DOMContentLoaded', function () {
    ////////////////////////////////////////////////
    // START - Video block
    if (document.querySelectorAll('[data-video]').length) {
        // console.log('is a video');
        // Load the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/player_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    // END - Video block
    ////////////////////////////////////////////////
});

window.onYouTubePlayerAPIReady = function () {
    // Replace the 'ytplayer' element with an <iframe> and
    // YouTube player after the API code downloads.
    // An array of youtube players
    var players = [];

    document.querySelectorAll('[data-video]').forEach(function (el, index) {
        var videoId = el.getAttribute('data-video');
        // console.log({ videoId });
        var elementId = 'ytplayer' + index;
        el.setAttribute('id', elementId);
        players[elementId] = new YT.Player(elementId, {
            height: '360',
            width: '640',
            videoId: videoId,

    host: 'https://www.youtube.com',
            playerVars: {
                rel: 0,
                modestbranding: 1,

        'origin': window.location.origin 
            },
            events: {
                onReady: function (event) {
                    var iframe = document.getElementById(elementId);
                    // iframe.setAttribute('loading', 'lazy')
                    var videoWrap = iframe.closest('.video-wrap');
                    videoWrap.classList.remove('loading');
                    videoWrap.classList.add('ready');
                    var playButton = videoWrap.querySelector('.video-wrap__play');
                    playButton.removeAttribute('disabled');
                    playButton.addEventListener('click', function () {
                        players[elementId].playVideo();
                    });
                },
                onStateChange: function (event) {
                    document.getElementById(elementId)
                        .closest('.video-wrap')
                        .classList.add('interacted');
                }
            }
        });
    });
}